<template>
  <dialog
    id="mini-calendar-filter-modal"
    class="modal__lightbox mini-calendar-filter-modal"
    closedby="any"
  >
    <div class="modal__container" role="dialog" aria-label="Event Filters">
      <button href="#" class="modal__close" @click="closeModal">
        <span class="visible-for-screen-readers">Close Filters</span>
        <span class="modal__close-icon" aria-hidden="true"></span>
      </button>
      <div class="modal__content" id="modal-1-content">
        <MiniCalendarFilters
          @month-changed="$emit('month-changed', $event)"
          :filters="temporaryFilter"
          @updateFilters="updateTemporaryFilters"
        />
      </div>
      <footer class="modal__footer">
        <button class="modal__btn show-results" @click="closeModal">
          Show Results
        </button>
      </footer>
    </div>
  </dialog>
</template>

<script>
import MiniCalendarFilters from "./mini-calendar-filters.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    MiniCalendarFilters,
  },
  data() {
    return {
      temporaryFilter: {},
    };
  },
  computed: {
    ...mapGetters(["selectedMonth"]),
  },
  methods: {
    updateTemporaryFilters(filters) {
      this.temporaryFilter = filters;
    },
    closeModal() {
      const dialog = document.getElementById("mini-calendar-filter-modal");
      if (dialog) {
        dialog.close();
      }
    },
  },
  mounted() {
    // Add event listener to the "Show Results" button
    const showResultsBtn = document.querySelector(".show-results");
    if (showResultsBtn) {
      showResultsBtn.addEventListener("click", this.closeModal);
    }

    // Add event listener to the close button (optional, as it may already have functionality)
    const closeBtn = document.querySelector(".closeDialog");
    if (closeBtn) {
      closeBtn.addEventListener("click", this.closeModal);
    }
  },
  beforeUnmount() {
    // Clean up event listeners
    const showResultsBtn = document.querySelector(".show-results");
    if (showResultsBtn) {
      showResultsBtn.removeEventListener("click", this.closeModal);
    }

    const closeBtn = document.querySelector(".closeDialog");
    if (closeBtn) {
      closeBtn.removeEventListener("click", this.closeModal);
    }
  },
};
</script>
